import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from '../FontIcon';
import './PencilIcon.css';

function PencilIcon({ className, size, title, alt, filled, disabled }) {
  return (
    <FontIcon
      icon="pencil"
      className={`pencil-icon ${className || ''} ${size || ''}`}
      title={title}
      alt={alt}
      filled={filled}
      disabled={disabled}
    />
  );
}

PencilIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default PencilIcon;
